/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `24H` - 24 Hours
 * * `OVERNIGHT` - Overnight
 * * `DAY` - Day
 * * `CALL` - Call Shift
 */
export enum ProviderRateTypeEnum {
    _24H = '24H',
    OVERNIGHT = 'OVERNIGHT',
    DAY = 'DAY',
    CALL = 'CALL',
}
